/**
 * Returns the container link where an event is triggered or undefined if not nested in link tag
 * @param event
 */
export default function getTargetLink(event) {
    let target = event.target;
    while (target && target.tagName !== "A") {
        target = target.parentNode;
    }
    return target;
}